import VersionContent from '.';
const VersionIosPage = () => {
  return <VersionContent systemPlatform={1} />;
};

export default VersionIosPage;
